import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { isEmail } from "validator";
import AuthService from "../services/AuthService";
import EstudianteService from "../services/EstudianteService";
import PeriodoService from "../services/PeriodoService";
import { Modal, Button, Alert } from "react-bootstrap";

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Este campo es requerido
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        El email no es válido
      </div>
    );
  }
};

const vusername = value => {
  if (value.length < 3 || value.length > 20) {
    return (
      <div className="alert alert-danger" role="alert">
        The username must be between 3 and 20 characters.
      </div>
    );
  }
};

const vnombre = value => {
  if (value.length < 3 || value.length > 30) {
    return (
      <div className="alert alert-danger" role="alert">
        El campo nombre debe tener una longitud entre 3 y 20 caractéres
      </div>
    );
  }
};

const vapellido = value => {
  if (value.length < 3 || value.length > 30) {
    return (
      <div className="alert alert-danger" role="alert">
        El campo apellido debe tener una longitud entre 3 y 20 caractéres
      </div>
    );
  }
};

const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alert alert-danger" role="alert">
        La contraseña debe tener entre 6 a 40 caracteres.
      </div>
    );
  }
};

export default class Register extends Component {
  constructor(props) {
    super(props);
    this.handleRegister = this.handleRegister.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangeNombre = this.onChangeNombre.bind(this);
    this.onChangeApellido = this.onChangeApellido.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);

    this.state = {
      username: "",
      nombre: "",
      apellido: "",
      email: "",
      password: "",
      successful: false,
      message: "",
      isDisabled: true,
      showModal: false,
      periodoActivo: null,
      loadingPeriodo: true
    };
  }

  componentDidMount() {
    this.verificarPeriodo();
  }

  verificarPeriodo = async () => {
    try {
      const response = await PeriodoService.getActivo();
      this.setState({
        periodoActivo: response.data || null,
        loadingPeriodo: false
      });
    } catch (error) {
      this.setState({
        periodoActivo: null,
        loadingPeriodo: false
      });
    }
  };

  onChangeUsername(e) {
    this.setState({
      username: e.target.value
    });
  }

  onChangeNombre(e) {
    this.setState({
      nombre: e.target.value
    });
  }

  onChangeApellido(e) {
    this.setState({
      apellido: e.target.value
    });
  }

  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  async validateByCedula(cedula) {
    try {
      // Validación simple para evitar llamadas innecesarias
      if (!/^\d{10}$/.test(cedula)) {
        this.setState({
          nombre: '',
          apellido: '',
          email: '',
          password: '',
          successful: false,
          showModal: true,
          message: 'Cédula inválida. Debe contener 10 dígitos.',
          isDisabled: true
        });
        return;
      }

      // 1) Verificar primero en AUTH si existe la cédula
      const userRes = await AuthService.getByCedula(cedula);
      if (!userRes || userRes.status === 404 || !userRes.data) {
        // Si no existe en AUTH, no llamamos a Estudiante (evita 404 extra)
        this.setState({
          nombre: '',
          apellido: '',
          email: '',
          password: '',
          successful: false,
          showModal: true,
          message: 'La cédula ingresada no se encuentra habilitada en el Periodo vigente',
          isDisabled: true
        });
        return;
      }

      // Autocompletar nombres si existe en AUTH
      this.setState({
        nombre: userRes.data.nombre || '',
        apellido: userRes.data.apellido || '',
        message: '',
        isDisabled: false
      });

      // 2) Verificar si ya existe solicitud en Estudiante
      const estudianteRes = await EstudianteService.getByCedula(cedula);
      if (estudianteRes && estudianteRes.status === 200 && estudianteRes.data) {
        this.setState({
          nombre: '',
          apellido: '',
          email: '',
          password: '',
          successful: false,
          showModal: true,
          message: 'La cédula ingresada ya tiene una solicitud registrada',
          isDisabled: true
        });
        return;
      }

      // Si no existe solicitud, queda habilitado para registrar (ya seteado arriba)
    } catch (err) {
      // No logueamos en consola para evitar ruido
      this.setState({
        nombre: '',
        apellido: '',
        email: '',
        password: '',
        successful: false,
        showModal: true,
        message: 'No se ha podido validar la cédula. Intenta nuevamente.',
        isDisabled: true
      });
    }
  }


  handleCloseModal() {
    this.setState({ 
      showModal: false,
      message: ''
    });
    // If registration was successful, redirect to login
    if (this.state.successful) {
      this.props.history.push('/login');
    }
  }

  handleRegister(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false,
      showModal: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.register(
        this.state.username,
        this.state.nombre,
        this.state.apellido,
        this.state.email,
        this.state.password
      ).then(
        response => {
          this.setState({
            message: response.data.message,
            successful: true,
            showModal: true
          }, () => {
            // Redirigir a login después de 3 segundos
            setTimeout(() => {
              this.handleCloseModal();
              this.props.history.push('/login');
            }, 3000);
          });
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          this.setState({
            successful: false,
            message: resMessage,
            showModal: true
          });
        }
      );
    }
  }

  render() {
    const {
        isDisabled,
        periodoActivo,
        loadingPeriodo
    } = this.state;

    if (loadingPeriodo) {
      return (
        <div className="row page-bg">
          <div className="col-md-12">
            <div className="card card-container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '200px' }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Cargando...</span>
              </div>
              <p className="mt-3 mb-0 text-center">Cargando... Verificando disponibilidad de inscripciones</p>
            </div>
          </div>
        </div>
      );
    }

    if (!periodoActivo) {
      return (
        <div className="row page-bg">
          <div className="col-md-12">
            <div className="card card-container">
              <h3 className="text-center">Atención:</h3>
              <p className="card-text text-center">El período de inscripciones se encuentra cerrado en este momento.</p>
              <p className="card-text text-center text-muted">Para más información, comuníquese con la institución.</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="row page-bg"> 
        <div className="col-md-12">
          <div className="card card-container">
          <h3 className="text-center">Registro de Usuario</h3>

            <Form
              onSubmit={this.handleRegister}
              ref={c => {
                this.form = c;
              }}
            >
              {!this.state.successful && (
                <div>
                  <div className="form-group">
                    <label htmlFor="username">Usuario (Cédula de identidad)</label>
                    <div className="input-group">
                      <Input
                        type="text"
                        className="form-control"
                        name="username"
                        value={this.state.username}
                        onChange={this.onChangeUsername}
                        validations={[required, vusername]}
                      />
                      <div className="input-group-append">
                      <button className="btn btn-secondary" 
                        type="button"
                        onClick={()=>{this.validateByCedula(this.state.username)}}
                      >
                        <FontAwesomeIcon icon="search"/>
                      </button>
                      </div>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="nombre">Nombres</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="nombre"
                      value={this.state.nombre}
                      onChange={this.onChangeNombre}
                      validations={[required, vnombre]}
                      disabled={true}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="apellido">Apellidos</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="apellido"
                      value={this.state.apellido}
                      onChange={this.onChangeApellido}
                      validations={[required, vapellido]}
                      disabled={true}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <Input
                      type="text"
                      className="form-control"
                      name="email"
                      value={this.state.email}
                      onChange={this.onChangeEmail}
                      validations={[required, email]}
                      disabled={isDisabled}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="password">Contraseña</label>
                    <Input
                      type="password"
                      className="form-control"
                      name="password"
                      value={this.state.password}
                      onChange={this.onChangePassword}
                      validations={[required, vpassword]}
                      disabled={isDisabled}
                    />
                  </div>

                  <div className="form-group">
                    <button className="btn btn-primary btn-block" disabled={isDisabled}>Registrar</button>
                  </div>
                </div>
              )}

              <Modal show={this.state.showModal} onHide={this.handleCloseModal} centered>
                <Modal.Header closeButton className={`border-0 pb-0 ${this.state.successful ? 'text-success' : 'text-danger'}`}>
                  <Modal.Title>
                    <FontAwesomeIcon 
                      icon={this.state.successful ? 'check' : 'ban'} 
                      className="me-2"
                    />
                    {this.state.successful ? 'Registro Exitoso' : 'Advertencia'}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                  <p className="mb-0">
                    {this.state.successful 
                      ? '¡Tu registro se ha completado con éxito! Por favor inicia sesión.'
                      : this.state.message}
                  </p>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                  <Button 
                    variant={this.state.successful ? 'success' : 'danger'}
                    onClick={this.handleCloseModal}
                    className="w-100"
                  >
                    Aceptar
                  </Button>
                </Modal.Footer>
              </Modal>
              <CheckButton
                style={{ display: "none" }}
                ref={c => {
                  this.checkBtn = c;
                }}
              />
            </Form>
          </div>
        </div>
      </div>
      
    );
  }
}